import React, { useEffect, useState } from "react";
import WhatsApp from "../../assets/images/WhatsApp.png";
import Gmail from "../../assets/images/logos_google-gmail.png";
import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  Pagination,
  Radio,
  Row,
  Space,
  Typography,
} from "antd";
import { useAxios } from "../../hooks/useAxios";
import { useNotification } from "../../contexts/NotificationProvider";
import ReusableButton from "../FormFields/ReusableButton";
import SearchInput from "../FormFields/SearchInput";

const { Title } = Typography;
const SendNotifications = () => {
  const [isSendModalOpen, setSendModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [weeks, setWeeks] = useState([]);
  const notify = useNotification();
  const [loadingNotification, setLoadingNotification] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { axiosInstance } = useAxios();
  const [form] = Form.useForm();
  const selectedWeek = Form.useWatch("week_id", form);
  let itemsPerPage = 3;

  const paginatedWeeks = weeks.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const closeModal = () => {
    setSendModalOpen(false);
    setSelectedAction("");
    form.resetFields();
  };
  const openModal = (actionUrl) => {
    setSendModalOpen(true);
    setSelectedAction(actionUrl);
  };
  const options = [
    // {
    //   icon: WhatsApp,
    //   title: "Whatsapp Notification",
    //   description: "Send via WhatsApp",
    //   actionUrl: "",
    //   actionButtonText: "Send via WhatsApp",
    //   disabled: true,
    // },
    {
      icon: Gmail,
      title: "Email Notification",
      description: "Send via Email",
      actionUrl: "",
      actionButtonText: "Send via Email",
      disabled: weeks.length === 0,
    },
  ];
  const sendAction = async (formData) => {
    const { week_id } = formData;
    setLoadingNotification(true);
    try {
      const response = await axiosInstance.post(
        "/api/rota/email/notification/",
        {
          week_id: week_id,
        }
      );
      notify({
        type: "success",
        message: response?.data?.success,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingNotification(false);
      closeModal();
    }
  };
  const fetchWeeks = async (searchTerm = "") => {
    try {
      const params = searchTerm ? { search: searchTerm } : {};
      const response = await axiosInstance.get("/api/weeks/list/", { params });
      const filteredWeeks = response.data?.filter((week) => week.has_week_data);
      setWeeks(filteredWeeks);
    } catch (error) {
      console.error(error);
    }
  };
  const handleSearch = async (value) => {
    await fetchWeeks(value);
  };
  useEffect(() => {
    fetchWeeks();
    //eslint-disable-next-line
  }, []);
  return (
    <>
      <Modal
        title="Send Notification"
        open={isSendModalOpen}
        onCancel={closeModal}
        wrapClassName="main-modal-class notification-modal"
        footer={[
          <Button
            style={{
              backgroundColor: "transparent",
              color: "#324054",
              border: "none",
              borderRadius: "4px",
              padding: "0 16px",
              height: "40px",
              fontWeight: 600,
              width: "118px",
            }}
            variant="text"
            onClick={closeModal}
          >
            Cancel
          </Button>,
          <ReusableButton
            text="Send"
            loading={loadingNotification}
            onClick={() => form.submit()}
            disabled={loadingNotification || !selectedWeek}
            backgroundColor="#212180"
            hoverBackgroundColor="#1A1E6A"
            disabledBackgroundColor="#B0B3C8"
          />,
        ]}
        className="upload-csv-modal"
      >
        <div style={{ marginBottom: "16px" }}>
          <SearchInput
            onSearch={handleSearch}
            placeholder="Search weeks"
            style={{ width: "100%" }}
          />
        </div>
        <Form
          form={form}
          layout="vertical"
          name="sendNotificationForm"
          requiredMark={false}
          onFinish={sendAction}
        >
          {weeks.length > 0 ? (
            <>
              <Form.Item
                name="week_id"
                label={null}
                rules={[
                  {
                    required: true,
                    message: "A week must be selected to continue.",
                  },
                ]}
              >
                <Radio.Group>
                  <Space direction="vertical">
                    {paginatedWeeks.map((week) => (
                      <Radio key={week.id} value={week.id}>
                        {week.title} ({week.start_date})
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Form.Item>
              <div style={{ marginTop: 16 }}>
                <Pagination
                  current={currentPage}
                  pageSize={itemsPerPage}
                  total={weeks.length}
                  onChange={handlePageChange}
                  align="end"
                  className="custom-pagination"
                />
              </div>
            </>
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Typography.Text
                type="secondary"
                style={{ fontSize: "20px", fontWeight: "500" }}
              >
                No week found
              </Typography.Text>
            </div>
          )}
        </Form>
      </Modal>

      <Row className="notifications-row" gutter={[24, 24]}>
        {options.map((option, index) => {
          return (
            <Col span={24} md={12} lg={8} key={index}>
              <Card>
                <img src={option.icon} alt={option.title} />
                <Title level={3} style={{ textAlign: "center" }}>
                  {option.title}
                </Title>
                <Title level={5} style={{ textAlign: "center" }}>
                  {option.description}
                </Title>
                <ReusableButton
                  text={option.actionButtonText}
                  onClick={() => openModal(option.actionUrl)}
                  disabled={option.disabled}
                  backgroundColor="#212180"
                  hoverBackgroundColor="#1A1E6A"
                  disabledBackgroundColor="#B0B3C8"
                  width="190px"
                  height="40px"
                  padding="12px 15px"
                />
              </Card>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default React.memo(SendNotifications);